import { notify } from './notify'

interface RunUndoableOptions {
  /** Texto del aviso («Has salido de la lista de espera»). */
  message: string
  /** Etiqueta del botón (i18n `common.undo`). */
  undoLabel: string
  /** Aplica el cambio en la UI al momento (estado local / caché optimista). */
  apply: () => void
  /** Lo revierte si el usuario pulsa «Deshacer». */
  revert: () => void
  /** La petición real; se lanza al acabar la ventana sin deshacer. */
  commit: () => void
  /** Ventana para deshacer. */
  durationMs?: number
}

/**
 * Acción inmediata con «Deshacer» (en vez de un modal de confirmación) para cosas de un
 * toque que no se pueden revertir en el servidor sin perder algo (p.ej. el puesto en la
 * lista de espera: volver a apuntarse te pone al final).
 *
 * El cambio se ve al instante (`apply`) pero la petición NO sale hasta que acaba la
 * ventana: si el usuario deshace, `revert` y no se llega a llamar al servidor. Cerrar el
 * aviso (swipe) cuenta como «no deshacer» y confirma ya. Si el usuario cierra la app
 * dentro de la ventana, la acción no llega a enviarse (se queda como estaba): es el lado
 * seguro.
 */
export function runUndoable({
  message,
  undoLabel,
  apply,
  revert,
  commit,
  durationMs = 5000,
}: RunUndoableOptions): void {
  let settled = false
  const settle = (undo: boolean) => {
    if (settled) return
    settled = true
    if (undo) revert()
    else commit()
  }

  apply()
  notify.success(message, {
    duration: durationMs,
    action: { label: undoLabel, onClick: () => settle(true) },
    onAutoClose: () => settle(false),
    onDismiss: () => settle(false),
  })
}
